'use client';

import { createContext, useContext, useState, useEffect } from 'react';
import { LANGUAGES } from '../constants/languages';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // Always start with 'en' for both server and client
  const [language, setLanguage] = useState('en');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Mark as mounted and load language from localStorage
    setMounted(true);
    const savedLanguage = localStorage.getItem('language') || 'en';
    if (savedLanguage !== language) {
      setLanguage(savedLanguage);
    }
  }, []);

  useEffect(() => {
    // Save language to localStorage when it changes (only after mount)
    if (mounted) {
      localStorage.setItem('language', language);
    }
  }, [language, mounted]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);